import { atom } from 'recoil';
import { Session } from '~/backend/connector-api/connector-schemas';

export const sessionDataAtom = atom<Session | undefined>({
    key: 'sessionDataAtom',
    default: undefined,
});
